import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const withAuth = (WrappedComponent) => {
  return (props) => {

    // Get access token from Redux state (which is persisted)
    const accessToken = useSelector((state) => state.auth.accessToken);

    if (!accessToken) {
      return <Navigate to="/login" replace />;
    }

    

    return <WrappedComponent {...props} />;
  };
};

export default withAuth;
